// @flow

import React from 'react';
import type { Node } from 'react';
import { withTranslatedRouter } from 'shared_data/providers/url/withTranslatedRouter';
import { LayoutDefault } from 'shared_components/layouts/Default';
import { HOCAuthParams } from 'shared_hocs/auth/Params';
import { ForgotPasswordForm } from 'shared_components/forms/password/Forgot';
import { AuthContainer, AuthLogo, AuthBody } from 'shared_components/auth/containers/auth/Auth';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';

/**
 * ForgotPasswordPage
 *
 * @returns {Node}
 */
const ForgotPasswordPage = ({ pageConfig }: Object): Node => (
  <LayoutDefault hasFooter hasHeader showRecentArtworkWidget={false}>
    <AuthContainer
      {...(pageConfig && pageConfig.acl && pageConfig.acl.forward
        ? { forwardUrl: UrlAssembler.byRouteKey(pageConfig.acl.forward) }
        : null)}
    >
      {() => (
        <React.Fragment>
          <AuthLogo />
          <AuthBody>
            <ForgotPasswordForm />
          </AuthBody>
        </React.Fragment>
      )}
    </AuthContainer>
  </LayoutDefault>
);

export default HOCAuthParams(withTranslatedRouter(ForgotPasswordPage));
